import { ReactNode } from 'react';
import { Button } from '@redis-ui/components';
import { PlusIcon } from '@redis-ui/icons';
import { IFontSize } from '../../types/styled';
import * as S from './EmptyListsFallback.style';
import { PermissionKey } from '../PermissionsProtectors/protectedComponents.types';
import ProtectedComponent from '../PermissionsProtectors/components/ProtectedComponent/ProtectedComponent';
import { ProtectedComponentOptions } from '../PermissionsProtectors/components/ProtectedComponent/ProtectedComponent.types';

interface ButtonProps {
  buttonName: string;
  handleClick: () => void;
}

type ButtonPropsCondition = ButtonProps | { buttonName?: undefined; handleClick?: undefined };

interface IProps {
  text: string;
  description?: string;
  plusIcon?: boolean;
  handleClick?: () => void;
  buttonRequiredPermission?: PermissionKey;
  fontSize?: IFontSize;
  fontSizeDescription?: IFontSize;
  bold?: boolean;
  marginTop?: string;
  disabled?: boolean;
  buttonDataTestId?: string;
  protectedComponentProps?: ProtectedComponentOptions;
  logo?: S.Logo;
  children?: ReactNode;
}

const EmptyListsFallback = (props: IProps & ButtonPropsCondition) => {
  const {
    text,
    description,
    buttonName,
    plusIcon,
    handleClick,
    fontSize = 's18',
    fontSizeDescription = 's14',
    bold = true,
    marginTop = '12vh',
    disabled = false,
    buttonDataTestId,
    buttonRequiredPermission,
    protectedComponentProps = {},
    children,
    logo
  } = props;

  const getButtonProps = () => {
    const buttonProps = {
      onClick: handleClick,
      disabled
    };

    if (buttonDataTestId) {
      buttonProps['data-testid'] = `button--${buttonDataTestId}`;
    }

    return buttonProps;
  };
  const buttonUi = (
    <S.ButtonContainer>
      <Button {...getButtonProps()} size="large">
        {plusIcon && <Button.Icon customSize="1.6rem" icon={PlusIcon} />}
        {buttonName}
      </Button>
    </S.ButtonContainer>
  );

  return (
    <S.Container data-testid="empty-fallback" marginTop={marginTop}>
      {logo && <S.LogoIcon logo={logo} />}
      <S.Label data-role="lead" {...{ fontSize, bold }}>
        {text}
      </S.Label>
      {description && (
        <S.Description {...{ fontSize: fontSizeDescription, bold: false }}>
          {description}
        </S.Description>
      )}
      {children}
      {buttonName &&
        (buttonRequiredPermission ? (
          <ProtectedComponent
            {...protectedComponentProps}
            requiredPermissions={buttonRequiredPermission}
          >
            {buttonUi}
          </ProtectedComponent>
        ) : (
          buttonUi
        ))}
    </S.Container>
  );
};

export default EmptyListsFallback;
